// extracted by mini-css-extract-plugin
export default {"dialog":"picturesDialog_dialog__FDSFl","picturesGridContainer":"picturesDialog_picturesGridContainer__4AR3+"};